module.exports = __webpack_public_path__ + "img/z1.5c1678f1.jpeg";